module.exports = __webpack_public_path__ + "img/agent-white.7ca5a8ec.png";